<template>
    <img src="@/assets/images/bull.jpg" />
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
img {
    display: block;
    width: 300 * $rem;
    height: 300 * $rem;
    animation: rotating 4s linear infinite;
    margin: auto;
    padding: 37 * $rem;
    border-radius: 50%;
}

@keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>